import { render, staticRenderFns } from "./CheckoutDescriptionSteps.vue?vue&type=template&id=0b134a86&scoped=true"
import script from "./CheckoutDescriptionSteps.vue?vue&type=script&lang=js"
export * from "./CheckoutDescriptionSteps.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDescriptionSteps.vue?vue&type=style&index=0&id=0b134a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b134a86",
  null
  
)

export default component.exports